module.exports = __webpack_public_path__ + "img/intro_s3_icon1.e16530a7.png";